export const inputGroupNames =
{
    AreaDemarcada: "AreaDemarcada",
    AreaDesmembrada: "AreaDesmembrada",
    AreaRemembrada: "AreaRemembrada",
    AreasLotes: "areasLotes",
    AreasVerdes: "areasVerdes",
    AreasSistViario: "areasSistViario",
    Pavimentos: "pavimentos",
    UnidHad: "unidadesHabitacionais",
    RegistrosMatriculas: "registrosMatriculas",
    RespTec: "respTec",
    TaxasOcup: "taxasOcupacao",
    DadosObraInfra: "dadosObraInfra",
    MarcosRef: "marcoRef",
    Testemunha: "testemunha",
    DocsOrigemMulta: "docsOrigemMulta",
}